/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, April 25th 2022, 4:53:47 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import * as React from "react";
import { AlertSnackBar, AlertSnackBarProps, useToggleState } from "ui-widgets";

interface FormSubmitErrorSnackbarProps {
  isAPIDataSendError: boolean;
  errorMessage: string;
  alertProps?: Partial<AlertSnackBarProps>;
}

export const FormSubmitErrorSnackbar = ({
  isAPIDataSendError,
  errorMessage,
  alertProps,
}: FormSubmitErrorSnackbarProps) => {
  const {
    handleClose: handleCloseErrorSnackBar,
    handleOpen: handleOpenErrorSnackBar,
    open: showErrorSnackBar,
  } = useToggleState();

  React.useEffect(() => {
    isAPIDataSendError && handleOpenErrorSnackBar();
  }, [isAPIDataSendError, handleOpenErrorSnackBar]);

  return (
    <AlertSnackBar
      open={showErrorSnackBar}
      message={errorMessage}
      severity="error"
      vertical={alertProps?.vertical ? alertProps?.vertical : "top"}
      horizontal={alertProps?.horizontal ? alertProps?.horizontal : "center"}
      handleClose={handleCloseErrorSnackBar}
    />
  );
};
